import styled from "styled-components";
import { Link } from "../../../components/Router/Link";
import { mediaQueryMaxMedium } from "../../../mediaQuery";
import { SIDEBAR } from "../constants";

const ICON_WRAPPER_SIZE = 40;
const SIDEBAR_PADDING_HORIZONTAL = SIDEBAR.basePadding * 2;

export const AppContainer = styled.div`
  isolation: isolate;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "header header"
    "aside main";
  height: 100%;
  box-sizing: border-box;
  font: var(--sinch-sys-font-body-m);
`;

export const HEADER_HEIGHT = 64;
export const HEADER_HEIGHT_MOBILE = 64;

export const HeaderContainer = styled.header`
  grid-area: header;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${HEADER_HEIGHT}px;
  box-sizing: border-box;
  padding: 0 ${SIDEBAR_PADDING_HORIZONTAL}px;
  border-bottom: 1px solid var(--sinch-sys-color-surface-tertiary-active);
  background-color: var(--sinch-sys-color-surface-primary-default);
  ${mediaQueryMaxMedium} {
    height: ${HEADER_HEIGHT_MOBILE}px;
    padding: 0 16px;
    position: relative;
  }
`;

export const HeaderColumn = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-sizing: border-box;
`;

export const MainContainer = styled.main`
  grid-area: main;
  overflow: auto;
  background-color: var(--sinch-sys-color-surface-primary-default);
`;

export const SinchIconContainer = styled(Link).attrs({ to: "/" })`
  width: ${ICON_WRAPPER_SIZE}px;
  height: ${ICON_WRAPPER_SIZE}px;
  align-items: center;
  justify-content: center;
  display: flex;
  ${mediaQueryMaxMedium} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
